export default __webpack_public_path__ + "static/media/GreatVibes-Regular.f51f1a4f.ttf";